var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBottomSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_173_14016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_173_14016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57518 9.55C5.44185 9.55 5.31268 9.525 5.18768 9.475C5.06268 9.425 4.95852 9.35833 4.87518 9.275L0.275183 4.675C0.0918498 4.49167 0.000183105 4.25833 0.000183105 3.975C0.000183105 3.69167 0.0918498 3.45833 0.275183 3.275C0.458516 3.09167 0.69185 3 0.975183 3C1.25852 3 1.49185 3.09167 1.67518 3.275L5.57518 7.175L9.47518 3.275C9.65852 3.09167 9.89185 3 10.1752 3C10.4585 3 10.6918 3.09167 10.8752 3.275C11.0585 3.45833 11.1502 3.69167 11.1502 3.975C11.1502 4.25833 11.0585 4.49167 10.8752 4.675L6.27518 9.275C6.17518 9.375 6.06685 9.44583 5.95018 9.4875C5.83352 9.52917 5.70852 9.55 5.57518 9.55Z",
    fill: "#2EBF93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomSmall);
export default __webpack_public_path__ + "static/media/arrow-bottom-small.b5a530c6d6dc76a34ba8cecd5f6a4523.svg";
export { ForwardRef as ReactComponent };